<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 d-flex flex-column">
      <app-header></app-header>
      <div class="card">
        <div class="card-body d-flex flex-column justify-content-center align-items-center">
          <img src="/static/assets/images/{{ data.image }}" alt="{{ data.imageTxt }}" />
          <h1 id="maintenance-header" class="mt-4">{{ data.header }}</h1>
          <p id="maintenance-text">{{ data.message }}</p>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>
